import OnvoBase from "../base.js";

export class OnvoUtils extends OnvoBase {
  /**
   * Uploads a file to a given bucket
   *
   * @param {Object} filters - The filters to apply to the question list.
   * @param {string} filters.dashboard - The ID of the dashboard to list questions for.
   * @returns {Promise<Question[]>} A promise that resolves to an array of questions.
   */
  async uploadFile(file: File) {
    const formData = new FormData();
    formData.set("file", file);
    return this._fetchBase(
      "/api/utils/upload-file",
      "POST",
      formData,
      true
    ) as Promise<{ url: string }>;
  }

  /**
   * Triggers the agent test and waits for completion via WebSocket.
   * If the server responds 202 with socket info, this method connects automatically
   * and resolves when 'job.completed' is received, or rejects on 'job.error'.
   */
  async testAgent(
    agent: "programmer" | "analyst",
    onProgress?: (event: any) => void
  ): Promise<any> {
    return this._fetchStreamBase(
      `/api/internal/openai/test-agent?agent=${agent}`,
      "POST",
      undefined,
      onProgress
    );
  }
}
